module.exports = {
	"config": {
		"siteTitle": "Irukanji",
		"siteDescr": "Psychedelic Electronica",
		"siteBandcampUrl": "https://irukanji.bandcamp.com",
		"siteSoundcloudUrl": "https://soundcloud.com/irukanji-music",
		"siteFacebookUrl": "https://www.facebook.com/irukanji.music",
		"siteDiscogsUrl": "http://www.discogs.com/artist/1375976-Irukanji",
		"siteTwitterUrl": "https://twitter.com/irukanji_music",
		"siteGoogleplusUrl": "",
		"siteGithubUrl": "https://github.com/irukanji-music",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2007-02-09-va-fantazma",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2007-02-09-va-fantazma",
				"stem": "index",
				"path": "discography/2007-02-09-va-fantazma/index.md"
			},
			"requirePath": "discography/2007-02-09-va-fantazma/index.md",
			"path": "/release/va-fantazma/",
			"data": {
				"id": 1,
				"title": "VA «Fantazma»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-fantazma/",
				"key": "va-fantazma",
				"meta": "VA - Fantazma by Sentimony Records",
				"keywords": "VA Fantazma, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/fantazma",
				"label-link": "sentimony.com/release/va-fantazma",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-fantazma",
				"label-bandcamp-id": 3399361938,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 3110776069,
				"bandcamp-track2": 1810845756,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Fantazma/release/952240"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2007-06-19-va-emptinesses",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2007-06-19-va-emptinesses",
				"stem": "index",
				"path": "discography/2007-06-19-va-emptinesses/index.md"
			},
			"requirePath": "discography/2007-06-19-va-emptinesses/index.md",
			"path": "/release/va-emptinesses/",
			"data": {
				"id": 2,
				"title": "VA «Emptinesses»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-emptinesses/",
				"key": "va-emptinesses",
				"meta": "VA - Emptinesses by Sentimony Records",
				"keywords": "VA Emptinesses, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/emptinesses",
				"label-link": "sentimony.com/release/va-emptinesses",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-emptinesses",
				"label-bandcamp-id": 2938863422,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 2357902888,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Emptinesses/release/1021635"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2007-06-27-va-skygravity-2-solar-system",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2007-06-27-va-skygravity-2-solar-system",
				"stem": "index",
				"path": "discography/2007-06-27-va-skygravity-2-solar-system/index.md"
			},
			"requirePath": "discography/2007-06-27-va-skygravity-2-solar-system/index.md",
			"path": "/release/va-skygravity-2-solar-system/",
			"data": {
				"id": 3,
				"title": "VA «Skygravity 2: Solar System»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-skygravity-2-solar-system/",
				"key": "va-skygravity-2-solar-system",
				"meta": "VA - Skygravity: Solar System by Skygravity Records",
				"keywords": "VA Skygravity 2 Solar System, Skygravity Records",
				"label": "Skygravity Records",
				"ektoplazm": null,
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": null,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Skygravity-Vol2-Solar-System/release/1021821"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2007-12-14-qarpa-in-zhir",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2007-12-14-qarpa-in-zhir",
				"stem": "index",
				"path": "discography/2007-12-14-qarpa-in-zhir/index.md"
			},
			"requirePath": "discography/2007-12-14-qarpa-in-zhir/index.md",
			"path": "/release/qarpa-in-zhir/",
			"data": {
				"id": 4,
				"title": "Qarpa «In Zhir»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/qarpa-in-zhir/",
				"key": "qarpa-in-zhir",
				"meta": "Qarpa - In Zhir by ЯОК Music",
				"keywords": "Qarpa, In Zhir, ЯОК Music",
				"label": "ЯОК Music",
				"ektoplazm": null,
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": null,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Qarpa-In-Zhir/release/1171759"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2007-12-20-sphingida-origin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2007-12-20-sphingida-origin",
				"stem": "index",
				"path": "discography/2007-12-20-sphingida-origin/index.md"
			},
			"requirePath": "discography/2007-12-20-sphingida-origin/index.md",
			"path": "/release/sphingida-origin/",
			"data": {
				"id": 5,
				"title": "Sphingida «Origin»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/sphingida-origin/",
				"key": "sphingida-origin",
				"meta": "Sphingida - Origin by Sentimony Records",
				"keywords": "Sphingida Origin, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/sphingida-origin",
				"label-link": "sentimony.com/release/sphingida-origin",
				"label-bandcamp": "sentimony.bandcamp.com/album/sphingida-origin",
				"label-bandcamp-id": 3680718383,
				"bandcamp-album": 728290111,
				"bandcamp-track": null,
				"bandcamp-lable-album": 728290111,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Sphingida-Origin/release/1171746"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2008-04-25-va-true-story",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2008-04-25-va-true-story",
				"stem": "index",
				"path": "discography/2008-04-25-va-true-story/index.md"
			},
			"requirePath": "discography/2008-04-25-va-true-story/index.md",
			"path": "/release/va-true-story/",
			"data": {
				"id": 6,
				"title": "VA «True Story»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-true-story/",
				"key": "va-true-story",
				"meta": "VA - True Story by Sentimony Records",
				"keywords": "VA True Story, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/true-story",
				"label-link": "sentimony.com/release/va-true-story",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-true-story",
				"label-bandcamp-id": 1223403780,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 2577162539,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-True-Story/release/1321723"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2008-10-13-va-lets-start-dreaming",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2008-10-13-va-lets-start-dreaming",
				"stem": "index",
				"path": "discography/2008-10-13-va-lets-start-dreaming/index.md"
			},
			"requirePath": "discography/2008-10-13-va-lets-start-dreaming/index.md",
			"path": "/release/va-lets-start-dreaming/",
			"data": {
				"id": 7,
				"title": "VA «Lets Start Dreaming»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-lets-start-dreaming/",
				"key": "va-lets-start-dreaming",
				"meta": "VA - Lets Start Dreaming by High Hopes Records",
				"keywords": "VA Lets Start Dreaming, High Hopes Records",
				"label": "High Hopes Records",
				"ektoplazm": null,
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": null,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Lets-Start-Dreaming-Vol-1/release/1500459"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2009-02-23-irukanji-z-lisu",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2009-02-23-irukanji-z-lisu",
				"stem": "index",
				"path": "discography/2009-02-23-irukanji-z-lisu/index.md"
			},
			"requirePath": "discography/2009-02-23-irukanji-z-lisu/index.md",
			"path": "/release/irukanji-z-lisu/",
			"data": {
				"id": 8,
				"title": "Irukanji «Z Lisu»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/irukanji-z-lisu/",
				"key": "irukanji-z-lisu",
				"meta": "Irukanji - Z Lisu by Sentimony Records",
				"keywords": "Z Lisu, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/irukanji-z-lisu",
				"label-link": "sentimony.com/release/irukanji-z-lisu",
				"label-bandcamp": "sentimony.bandcamp.com/album/irukanji-z-lisu",
				"label-bandcamp-id": 2924012921,
				"bandcamp-album": 2581336461,
				"bandcamp-track": null,
				"bandcamp-lable-album": 2581336461,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Irukanji-Z-Lisu/release/1664941"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2009-11-21-va-ocean-scenes-higher-titans",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2009-11-21-va-ocean-scenes-higher-titans",
				"stem": "index",
				"path": "discography/2009-11-21-va-ocean-scenes-higher-titans/index.md"
			},
			"requirePath": "discography/2009-11-21-va-ocean-scenes-higher-titans/index.md",
			"path": "/release/va-ocean-scenes-higher-titans/",
			"data": {
				"id": 9,
				"title": "VA «Ocean Scenes: Higher Titans»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-ocean-scenes-higher-titans/",
				"key": "va-ocean-scenes-higher-titans",
				"meta": "VA - Ocean Scenes: Higher Titans by Aqua Deep Music",
				"keywords": "VA Ocean Scenes Higher Titans, Aqua Deep Music, Sentimony Records",
				"label": "Aqua Deep Music",
				"ektoplazm": "free-music/ocean-scenes-higher-titans",
				"label-link": "aquadeepmusic.com/release/adcd01",
				"label-bandcamp": "aquadeep.bandcamp.com/album/va-ocean-scenes-higher-titans",
				"label-bandcamp-id": 3486103233,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 3077453451,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Ocean-Scenes-Higher-Titans/release/2023159"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2010-06-15-va-grower",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2010-06-15-va-grower",
				"stem": "index",
				"path": "discography/2010-06-15-va-grower/index.md"
			},
			"requirePath": "discography/2010-06-15-va-grower/index.md",
			"path": "/release/va-grower/",
			"data": {
				"id": 10,
				"title": "VA «Grower»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-grower/",
				"key": "va-grower",
				"meta": "VA - Grower by Lookinglook Records",
				"keywords": "VA Grower, Lookinglook Records",
				"label": "Lookinglook Records",
				"ektoplazm": "free-music/grower",
				"label-link": "lookinglook.com/release/va-grower",
				"label-bandcamp": "lookinglook.bandcamp.com/album/va-grower",
				"label-bandcamp-id": 4231998669,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 1413874919,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Grower/release/2356268"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2010-10-15-va-sound-drops",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2010-10-15-va-sound-drops",
				"stem": "index",
				"path": "discography/2010-10-15-va-sound-drops/index.md"
			},
			"requirePath": "discography/2010-10-15-va-sound-drops/index.md",
			"path": "/release/va-sound-drops/",
			"data": {
				"id": 11,
				"title": "VA «Sound Drops»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-sound-drops/",
				"key": "va-sound-drops",
				"meta": "VA - Sound Drops by Warp Brain Records",
				"keywords": "VA Sound Drops, Warp Brain Records",
				"label": "Warp Brain Records",
				"ektoplazm": null,
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 4120569002,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Sound-Drops/release/2481187"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2011-01-10-va-tempo-syndicate",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2011-01-10-va-tempo-syndicate",
				"stem": "index",
				"path": "discography/2011-01-10-va-tempo-syndicate/index.md"
			},
			"requirePath": "discography/2011-01-10-va-tempo-syndicate/index.md",
			"path": "/release/va-tempo-syndicate/",
			"data": {
				"id": 12,
				"title": "VA «Tempo Syndicate»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-tempo-syndicate/",
				"key": "va-tempo-syndicate",
				"meta": "VA - Tempo Syndicate by Sentimony Records",
				"keywords": "VA Tempo Syndicate, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/tempo-syndicate",
				"label-link": "sentimony.com/release/va-tempo-syndicate",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-tempo-syndicate",
				"label-bandcamp-id": 2483216888,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 2080900690,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Tempo-Syndicate/release/2645251"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2011-01-22-va-the-best-electronica-in-ua",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2011-01-22-va-the-best-electronica-in-ua",
				"stem": "index",
				"path": "discography/2011-01-22-va-the-best-electronica-in-ua/index.md"
			},
			"requirePath": "discography/2011-01-22-va-the-best-electronica-in-ua/index.md",
			"path": "/release/va-the-best-electronica-in-ua/",
			"data": {
				"id": 13,
				"title": "VA «The Best Electronica In UA»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-the-best-electronica-in-ua/",
				"key": "va-the-best-electronica-in-ua",
				"meta": "VA - The Best Electronica In UA by CTS Records",
				"keywords": "VA The Best Electronica In UA, CTS Records",
				"label": "CTS Records",
				"ektoplazm": null,
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": null,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-The-Best-Electronica-In-UA-Vol1/release/2889982"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2011-04-12-va-absence-of-gravity",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2011-04-12-va-absence-of-gravity",
				"stem": "index",
				"path": "discography/2011-04-12-va-absence-of-gravity/index.md"
			},
			"requirePath": "discography/2011-04-12-va-absence-of-gravity/index.md",
			"path": "/release/va-absence-of-gravity/",
			"data": {
				"id": 14,
				"title": "VA «Absence Of Gravity»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-absence-of-gravity/",
				"key": "va-absence-of-gravity",
				"meta": "VA - Absence Of Gravity by Sentimony Records",
				"keywords": "VA Absence Of Gravity, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/absence-of-gravity",
				"label-link": "sentimony.com/release/va-absence-of-gravity",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-absence-of-gravity",
				"label-bandcamp-id": 615519130,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 807150293,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Absence-Of-Gravity/release/2820972"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2012-01-10-va-special-places",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2012-01-10-va-special-places",
				"stem": "index",
				"path": "discography/2012-01-10-va-special-places/index.md"
			},
			"requirePath": "discography/2012-01-10-va-special-places/index.md",
			"path": "/release/va-special-places/",
			"data": {
				"id": 15,
				"title": "VA «Special Places»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-special-places/",
				"key": "va-special-places",
				"meta": "VA - Special Places by Sentimony Records",
				"keywords": "VA Special Places, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/special-places",
				"label-link": "sentimony.com/release/va-special-places",
				"label-bandcamp": "sentimony.bandcamp.com/album/va-special-places",
				"label-bandcamp-id": 64124286,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 430811055,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/AstroPilot-Special-Places/release/3517621"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2012-04-01-va-tabula-rasa",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2012-04-01-va-tabula-rasa",
				"stem": "index",
				"path": "discography/2012-04-01-va-tabula-rasa/index.md"
			},
			"requirePath": "discography/2012-04-01-va-tabula-rasa/index.md",
			"path": "/release/va-tabula-rasa/",
			"data": {
				"id": 16,
				"title": "VA «Tabula Rasa»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-tabula-rasa/",
				"key": "va-tabula-rasa",
				"meta": "VA - Tabula Rasa by Another Dimension Music",
				"keywords": "VA Tabula Rasa, Another Dimension Music",
				"label": "Another Dimension Music",
				"ektoplazm": null,
				"label-link": "anotherdimension.com.ua/releases/admcd001",
				"label-bandcamp": "anotherdimension.bandcamp.com/album/admcd001-v-a-tabula-rasa-sale",
				"label-bandcamp-id": 3940365719,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 3231222167,
				"bandcamp-track2": 2330700422,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Tabula-Rasa/release/3618811"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2012-08-07-hypnotriod-seven-heavenly-edges",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2012-08-07-hypnotriod-seven-heavenly-edges",
				"stem": "index",
				"path": "discography/2012-08-07-hypnotriod-seven-heavenly-edges/index.md"
			},
			"requirePath": "discography/2012-08-07-hypnotriod-seven-heavenly-edges/index.md",
			"path": "/release/hypnotriod-seven-heavenly-edges/",
			"data": {
				"id": 17,
				"title": "Hypnotriod «Seven Heavenly Edges»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/hypnotriod-seven-heavenly-edges/",
				"key": "hypnotriod-seven-heavenly-edges",
				"meta": "Hypnotriod - Seven Heavenly Edges by Sentimony Records",
				"keywords": "Hypnotriod, Seven Heavenly Edges, Sentimony Records",
				"label": "Sentimony Records",
				"ektoplazm": "free-music/hypnotriod-seven-heavenly-edges",
				"label-link": "sentimony.com/release/hypnotriod-seven-heavenly-edges",
				"label-bandcamp": "sentimony.bandcamp.com/album/hypnotriod-seven-heavenly-edges",
				"label-bandcamp-id": 2733998829,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 3570631252,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Hypnotriod-Seven-Heavenly-Edges/release/3618882"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2013-01-05-va-psyderchill-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2013-01-05-va-psyderchill-2",
				"stem": "index",
				"path": "discography/2013-01-05-va-psyderchill-2/index.md"
			},
			"requirePath": "discography/2013-01-05-va-psyderchill-2/index.md",
			"path": "/release/va-psyderchill-2/",
			"data": {
				"id": 18,
				"title": "VA «Psyderchill 2»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-psyderchill-2/",
				"key": "va-psyderchill-2",
				"meta": "VA - Psyderchill 2 by Psyderweb Records",
				"keywords": "VA Psyderchill 2, Psyderweb Records",
				"label": "Psyderweb Records",
				"ektoplazm": "free-music/psyderchill-2",
				"label-link": null,
				"label-bandcamp": null,
				"label-bandcamp-id": null,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 2218475650,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Harmonic-Frequency-Psyderchill-2/release/4207900"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2013-08-10-va-ukranian-dimension",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2013-08-10-va-ukranian-dimension",
				"stem": "index",
				"path": "discography/2013-08-10-va-ukranian-dimension/index.md"
			},
			"requirePath": "discography/2013-08-10-va-ukranian-dimension/index.md",
			"path": "/release/va-ukranian-dimension/",
			"data": {
				"id": 19,
				"title": "VA «Ukranian Dimension»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-ukranian-dimension/",
				"key": "va-ukranian-dimension",
				"meta": "VA - Ukranian Dimension by Another Dimension Music",
				"keywords": "VA Ukranian Dimension, Another Dimension Music",
				"label": "Another Dimension Music",
				"ektoplazm": "free-music/ukranian-dimension",
				"label-link": "anotherdimension.com.ua/releases/admcd003",
				"label-bandcamp": "anotherdimension.bandcamp.com/album/admcd003-v-a-ukranian-dimension-sale",
				"label-bandcamp-id": 841301218,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 204260206,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Ablepsia-Ukranian-Dimension/release/4833250"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2014-04-12-va-audio-elastique",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2014-04-12-va-audio-elastique",
				"stem": "index",
				"path": "discography/2014-04-12-va-audio-elastique/index.md"
			},
			"requirePath": "discography/2014-04-12-va-audio-elastique/index.md",
			"path": "/release/va-audio-elastique/",
			"data": {
				"id": 20,
				"title": "VA «Audio Elastique»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-audio-elastique/",
				"key": "va-audio-elastique",
				"meta": "VA - Audio Elastique by Another Dimension Music",
				"keywords": "VA Audio Elastique, Another Dimension Music",
				"label": "Another Dimension Music",
				"ektoplazm": null,
				"label-link": "anotherdimension.com.ua/releases/admcd004",
				"label-bandcamp": "anotherdimension.bandcamp.com/album/admcd004-v-a-audio-elastique-sale",
				"label-bandcamp-id": 2961371900,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 1887927502,
				"bandcamp-track2": 324651552,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": "http://www.discogs.com/Various-Audio-Elastique/release/5821893"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "discography/2015-06-15-va-space-invaders",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "discography/2015-06-15-va-space-invaders",
				"stem": "index",
				"path": "discography/2015-06-15-va-space-invaders/index.md"
			},
			"requirePath": "discography/2015-06-15-va-space-invaders/index.md",
			"path": "/release/va-space-invaders/",
			"data": {
				"id": 21,
				"title": "VA «Space Invaders»",
				"layout": "ReleasePage",
				"category": "discography",
				"path": "/release/va-space-invaders/",
				"key": "va-space-invaders",
				"meta": "VA - Space Invaders by Another Dimension Music",
				"keywords": "VA Space Invaders, Another Dimension Music",
				"label": "Another Dimension Music",
				"ektoplazm": null,
				"label-link": "anotherdimension.com.ua/releases/admcd006",
				"label-bandcamp": "anotherdimension.bandcamp.com/album/admcd006-v-a-space-invaders-out-now",
				"label-bandcamp-id": 908324355,
				"bandcamp-album": 2563369517,
				"bandcamp-track": 52697559,
				"bandcamp-track2": 2114718806,
				"bandcamp-lable-album": null,
				"bandcamp-lable-track": null,
				"discogs": null
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "discography.md",
				"ext": "md",
				"name": "discography",
				"extname": ".md",
				"basename": "discography.md",
				"dirname": "pages",
				"stem": "discography",
				"path": "pages/discography.md"
			},
			"requirePath": "pages/discography.md",
			"path": "/discography/",
			"data": {
				"title": "Discography",
				"layout": "Discography",
				"path": "/discography/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages",
				"stem": "index",
				"path": "pages/index.md"
			},
			"requirePath": "pages/index.md",
			"path": "/",
			"data": {
				"title": "Home",
				"layout": "HomePage",
				"path": "/"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0